import React from 'react'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'
import ME from '../../assets/pic3.png'
import "./Header.css"
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'


const Header = () => {
  return (
    
    <header>
     
      <div className="container header__container">
    
        <h5>Hello, c'est</h5>
        <h1> Zakaria Chajae</h1>
        <h5 className='text-light'> Fullstack developper </h5>
        
        <CTA/>
        <HeaderSocials />
        <div className='me'>
          <img src={ME} ></img>
        </div>
         <div className='scroll__down'>
        <a href='https://www.linkedin.com/in/chajae-zakaria-9a1620153/' target='_blank'><BsLinkedin/></a>
        <a href='https://github.com/zakariachajae' target='_blank'><BsGithub/></a>
        <a href='https://www.instagram.com/zakariachajae/' target='_blank'><BsInstagram /></a>
        </div>
      
      </div>
    </header>
   
  )
}

export default Header